export var IdDomElement;
(function (IdDomElement) {
    IdDomElement["CanvasMain"] = "canvas-main";
    IdDomElement["DomRoot"] = "root";
    IdDomElement["PortalRoot"] = "portal-root";
    IdDomElement["LevelUpAnimation"] = "level-up-animation";
})(IdDomElement || (IdDomElement = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdDomElement.ts
// module id = 368
// module chunks = 3